/*!
 * zeluslugi.ru
 * File: map-activity.js
 * (c) 2020 delphinpro <delphinpro@gmail.com>
 * licensed under the MIT license
 */

//"content": {
//             "title"   : "",
//             "address" : "",
//             "schedule": "",
//             "phone"   : "",
//             "email"   : [],
//         },
let GEO_POINTS_DEFAULT = [
    {
        center : true,
        geo    : [55.75399399999374, 37.62209300000001],
        content: { title: 'Москва' },
    },
    // , {
    //     center : false,
    //     geo    : [55.9254248381628,37.368024499999954],
    //     content: {title: 'Химки'},
    // }, {
    //     center : false,
    //     geo    : [55.984556528981855,37.1999325],
    //     content: {title: 'Зеленоград'},
    // }, {
    //     center : false,
    //     geo    : [52.9679925738214,36.09658099999989],
    //     content: {title: 'Орёл'},
    // }, {
    //     center : false,
    //     geo    : [55.54794424500634,34.98859399999997],
    //     content: {title: 'Гагарин'},
    // }, {
    //     center : false,
    //     geo    : [59.91807704072416,30.304899499999895],
    //     content: {title: 'Петербург'},
    // }, {
    //     center : false,
    //     geo    : [55.907243113390635,36.855405999999974],
    //     content: {title: 'Истра'},
    // }, {
    //     center : false,
    //     geo    : [57.008514583845454,40.99702549999998],
    //     content: {title: 'Иваново'},
    // }, {
    //     center : false,
    //     geo    : [55.693931277473155,37.66441950000001],
    //     content: {title: 'Московская обл. Технопарк М4'},
    // }, {
    //     center : false,
    //     geo    : [55.674034551602595,37.91624],
    //     content: {title: 'Люберцы'},
    // }, {
    //     center : false,
    //     geo    : [55.90951899159704,38.01697249999995],
    //     content: {title: 'г. Щёлково'},
    // }, {
    //     center : false,
    //     geo    : [55.946665178924015,37.49595849999999],
    //     content: {title: 'Долгопрудный'},
    // }, {
    //     center : false,
    //     geo    : [55.36406113949767,37.81914499999996],
    //     content: {title: 'Домодедово'},
    // }, {
    //     center : false,
    //     geo    : [47.250075388415006,39.653635499999936],
    //     content: {title: 'Ростов-на-Дону'},
    // }, {
    //     center : false,
    //     geo    : [56.26405721607763,34.35499950000001],
    //     content: {title: 'Ржев'},
    // },
];

$(function () {
    let selector = '#map-activity';
    let $block = $(selector);
    let $tplBalloon = $('#map-balloon');
    let $tplBalloonContent = $('#map-balloon-content');
    let $tplBalloonContact = $('#map-balloon-contact');

    if (!$block.length) return;

    let centerDefault = [55.89711159436251, 37.39985283213179];
    let customIcon = {
        iconLayout     : 'default#image',
        iconImageHref  : '/design/images/icons/point-red.png',
        iconImageSize  : [36, 56],
        iconImageOffset: [-18, -56],
    };

    let tplBalloon = $tplBalloon.length ? $tplBalloon.html() : null;
    let tplBalloonContent = $tplBalloonContent.length ? $tplBalloonContent.html() : null;
    let tplBalloonContact = $tplBalloonContact.length ? $tplBalloonContact.html() : null;

    let $api = $('<script/>', {
        src : '//api-maps.yandex.ru/2.1/?lang=ru_RU',
        type: 'text/javascript',
    });

    let i = setInterval(function () {
        if (!!window.ymaps) {
            clearInterval(i);

            console.info('Yandex map API has been loaded.');

            let points = window['GEO_POINTS'] || GEO_POINTS_DEFAULT;

            ymaps.ready(function () {
                let map = new ymaps.Map(selector.replace('#', ''), {
                    center: centerDefault,
                    zoom  : 5,
                });

                map.controls.remove('geolocationControl');
                map.controls.remove('searchControl');
                map.controls.remove('trafficControl');
                map.controls.remove('typeSelector');
                map.controls.remove('fullscreenControl');
                map.controls.remove('rulerControl');
                map.behaviors.disable(['scrollZoom']);

                let placemark0 = new ymaps.Placemark([55.684758, 37.738521], {
                    balloonContent: 'цвет <strong>воды пляжа бонди</strong>',
                }, {
                    preset   : 'islands#icon',
                    iconColor: '#0095b6',
                });

                for (let place of points) {
                    if (tplBalloon) {
                        let MyBalloonLayout = ymaps.templateLayoutFactory.createClass(tplBalloon, {
                            /**
                             * Строит экземпляр макета на основе шаблона и добавляет его в родительский HTML-элемент.
                             * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/layout.templateBased.Base.xml#build
                             * @function
                             * @name build
                             */
                            build: function () {
                                this.constructor.superclass.build.call(this);

                                this._$element = $('.map-balloon', this.getParentElement());

                                this.applyElementOffset();

                                this._$element.find('.close')
                                    .on('click', $.proxy(this.onCloseClick, this));
                            },

                            /**
                             * Удаляет содержимое макета из DOM.
                             * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/layout.templateBased.Base.xml#clear
                             * @function
                             * @name clear
                             */
                            clear: function () {
                                this._$element.find('.close')
                                    .off('click');

                                this.constructor.superclass.clear.call(this);
                            },

                            /**
                             * Метод будет вызван системой шаблонов АПИ при изменении размеров вложенного макета.
                             * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/IBalloonLayout.xml#event-userclose
                             * @function
                             * @name onSublayoutSizeChange
                             */
                            onSublayoutSizeChange: function () {
                                MyBalloonLayout.superclass.onSublayoutSizeChange.apply(this,
                                    arguments);

                                if (!this._isElement(this._$element)) {
                                    return;
                                }

                                this.applyElementOffset();

                                this.events.fire('shapechange');
                            },

                            /**
                             * Сдвигаем балун, чтобы "хвостик" указывал на точку привязки.
                             * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/IBalloonLayout.xml#event-userclose
                             * @function
                             * @name applyElementOffset
                             */
                            applyElementOffset: function () {
                                console.log('applyElementOffset');
                                this._$element.css({
                                    left: 20,
                                    // left: -(this._$element[0].offsetWidth / 2),
                                    // top : -(this._$element[0].offsetHeight + this._$element.find('.arrow')[0].offsetHeight)
                                    top: -(this._$element[0].offsetHeight / 2),
                                });
                            },

                            /**
                             * Закрывает балун при клике на крестик, кидая событие "userclose" на макете.
                             * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/IBalloonLayout.xml#event-userclose
                             * @function
                             * @name onCloseClick
                             */
                            onCloseClick: function (e) {
                                e.preventDefault();

                                this.events.fire('userclose');
                            },

                            /**
                             * Используется для автопозиционирования (balloonAutoPan).
                             * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/ILayout.xml#getClientBounds
                             * @function
                             * @name getClientBounds
                             * @returns {Number[][]} Координаты левого верхнего и правого нижнего углов шаблона относительно точки привязки.
                             */
                            getShape: function () {
                                if (!this._isElement(this._$element)) {
                                    return MyBalloonLayout.superclass.getShape.call(this);
                                }

                                let position = this._$element.position();

                                return new ymaps.shape.Rectangle(
                                    new ymaps.geometry.pixel.Rectangle([
                                        [position.left, position.top], [
                                            position.left + this._$element[0].offsetWidth,
                                            position.top + this._$element[0].offsetHeight +
                                            this._$element.find('.arrow')[0].offsetHeight,
                                        ],
                                    ]));
                            },

                            /**
                             * Проверяем наличие элемента (в ИЕ и Опере его еще может не быть).
                             * @function
                             * @private
                             * @name _isElement
                             * @param {jQuery} [element] Элемент.
                             * @returns {Boolean} Флаг наличия.
                             */
                            _isElement: function (element) {
                                return element && element[0] && element.find('.arrow')[0];
                            },
                        });

                        // Создание вложенного макета содержимого балуна.
                        let MyBalloonContentLayout = ymaps.templateLayoutFactory.createClass(
                            tplBalloonContent);

                        let balloonContent = '';

                        if (place.content.address) {
                            balloonContent += tplBalloonContact
                                .replace('<% icon %>', 'point')
                                .replace('<% content %>', place.content.address);
                        }

                        if (place.content.schedule) {
                            balloonContent += tplBalloonContact
                                .replace('<% icon %>', 'clock')
                                .replace('<% content %>', place.content.schedule);
                        }

                        if (place.content.phone) {
                            balloonContent += tplBalloonContact
                                .replace('<% icon %>', 'phone')
                                .replace('<% content %>', place.content.phone);
                        }

                        if (place.content.email) {
                            let emails = '';
                            for (let email of place.content.email) {
                                emails += `<p><a href="mailto:${email[0]}">${email[0]}</a> <em>${email[1]}</em></p>`;
                            }
                            balloonContent += tplBalloonContact
                                .replace('<% icon %>', 'mail')
                                .replace('<% content %>', emails);
                        }
                    }

                    let placemark;
                    if (tplBalloon) {
                        // Создание метки с пользовательским макетом балуна.
                        placemark = new ymaps.Placemark(place.geo, {
                            balloonHeader : place.content.title,
                            balloonContent: balloonContent,
                        }, $.extend(customIcon, {
                            balloonShadow         : false,
                            balloonLayout         : MyBalloonLayout,
                            balloonContentLayout  : MyBalloonContentLayout,
                            balloonPanelMaxMapArea: 0,
                            // Не скрываем иконку при открытом балуне.
                            hideIconOnBalloonOpen: false,
                            // И дополнительно смещаем балун, для открытия над иконкой.
                            balloonOffset: [3, 0],
                        }));
                    } else {
                        placemark = new ymaps.Placemark(place.geo, {
                            balloonContent: place.content.title,
                        }, {
                            preset   : 'islands#icon',
                            iconColor: '#33bc50',
                        });
                    }

                    map.geoObjects.add(placemark);

                    if (place.center) {
                        centerDefault = place.geo;
                    }
                }

                map.setCenter(centerDefault);

            });
        }
    }, 100);

    $api.appendTo(document.body);
});
